import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const ConcordiaUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Concordia University"
      universityShortName="Concordia"
      slug="concordia-university"
      seoTitle="Concordia University Study Rooms | Montreal Campus Study Guide"
      seoDescription="Complete guide to study rooms at Concordia University. Find Webster Library, Vanier Library, and Grey Nuns study spaces. Plus free 24/7 online alternative."
      seoKeywords="concordia study rooms, concordia library, webster library, vanier library, grey nuns building, montreal university study spaces"
      canonicalUrl="/study-room/concordia-university/"
      heroDescription="A comprehensive guide to study rooms at Concordia, including Webster Library, Vanier Library, and the Grey Nuns building."
      libraryWebsiteUrl="https://library.concordia.ca/"
      libraryWebsiteName="Concordia Library"
      studySpaces={[
        {
          name: "Webster Library - Zero-Noise Room (LB-361)",
          features: "Complete silence with no talking or keyboarding allowed.",
          feedback: "Loved for meditation-level silence; some find no-keyboard rule overly strict."
        },
        {
          name: "Webster Library - Graduate Study Rooms (5th Floor)",
          features: "Rooms like 'Iceland' and 'Venezuela' plus reading rooms with lockers.",
          feedback: "Good graduate spaces with character."
        },
        {
          name: "Webster Library - Group Rooms",
          features: "15 rooms across multiple floors with screens and AirMedia connections.",
          feedback: "Plentiful but still book up quickly."
        },
        {
          name: "Vanier Library - Graduate Study Room (VL-305)",
          features: "Bookable for up to three hours; accessible via access code.",
          feedback: "Good private space for graduate students."
        },
        {
          name: "Vanier Library - Group Rooms",
          features: "10 rooms on the third floor for group collaboration.",
          feedback: "Good alternative when Webster is full."
        },
        {
          name: "Grey Nuns Building",
          features: "14 group study rooms with large screens and AirMedia.",
          feedback: "Well-equipped for presentations and group work."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            For ultimate silence, try the <strong>zero-noise room</strong> or the graduate study rooms. For group work with technology, book one of the <strong>Grey Nuns or Webster rooms</strong>, which include large screens and AirMedia connections.
          </p>
          <p className="mb-4">
            Reservations are limited to <strong>three hours per day</strong> and <strong>three reservations per week</strong>. Remember the 15-minute grace period—arrive on time or lose your booking.
          </p>
          <p>
            Some students love the zero-noise room for meditation-level silence, while others find the no-keyboard rule overly strict.
          </p>
        </>
      }
      summaryTips={[
        "Try the zero-noise room: No talking or keyboards for complete silence.",
        "Book Grey Nuns rooms: 14 rooms with large screens and AirMedia.",
        "Remember the limits: Three hours per day, three reservations per week.",
        "Arrive within 15 minutes: Late arrivals lose their booking.",
        "Use CSW for unlimited access: No three-hour or three-booking limits."
      ]}
    />
  );
};

export default ConcordiaUniversity;
